import { format, parseISO } from 'date-fns'
import { hu } from 'date-fns/locale'

const HUF_FORMATTER = new Intl.NumberFormat('hu-HU', {
  style: 'currency',
  currency: 'HUF',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
})

const numberFormatters = new Map<string, Intl.NumberFormat>()

function getFormatter(currency: string): Intl.NumberFormat {
  if (currency === 'HUF') return HUF_FORMATTER
  let f = numberFormatters.get(currency)
  if (!f) {
    f = new Intl.NumberFormat('hu-HU', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    numberFormatters.set(currency, f)
  }
  return f
}

export function money(amount: number | null | undefined, currency: string = 'HUF'): string {
  if (amount === null || amount === undefined) return '—'
  return getFormatter(currency).format(amount)
}

/** Tömör verzió táblázathoz: "127 000 Ft" vagy "500 €". */
export function moneyCompact(amount: number | null | undefined, currency: string = 'HUF'): string {
  if (amount === null || amount === undefined) return '—'
  const formatted = new Intl.NumberFormat('hu-HU', {
    minimumFractionDigits: currency === 'HUF' ? 0 : 2,
    maximumFractionDigits: currency === 'HUF' ? 0 : 2,
  }).format(amount)
  const suffix =
    currency === 'HUF' ? ' Ft' : currency === 'EUR' ? ' €' : currency === 'USD' ? ' $' : ` ${currency}`
  return formatted + suffix
}

export function dateShort(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    return format(parseISO(iso), 'yyyy-MM-dd', { locale: hu })
  } catch {
    return iso
  }
}

export function dateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  try {
    return format(parseISO(iso), 'yyyy-MM-dd HH:mm', { locale: hu })
  } catch {
    return iso
  }
}

export function relativeFromNow(iso: string | null | undefined, now: Date): string {
  if (!iso) return '—'
  try {
    const d = parseISO(iso)
    const diffMs = now.getTime() - d.getTime()
    const sec = Math.round(diffMs / 1000)
    if (sec < 60) return `${sec} mp`
    const min = Math.round(sec / 60)
    if (min < 60) return `${min} p`
    const h = Math.round(min / 60)
    if (h < 48) return `${h} ó`
    const days = Math.round(h / 24)
    return `${days} nap`
  } catch {
    return iso
  }
}

export function monthLabel(year: number, month: number): string {
  return `${year}-${String(month).padStart(2, '0')}`
}

export function percent(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—'
  return `${n.toFixed(1)}%`
}
